export const ALL_CONSTANTS = {
	REGISTRATION_NOT_PERMISSIBLE: "Registeration is not Permissible!",
	"Registeration is not Permissible!": "REGISTRATION_NOT_PERMISSIBLE",
};
